// Utils
export const getArticlesByCat = function(cat) {
  return ARTICLES.filter(art => {
    return art.cats.includes(cat)
  })
}

export const getArticlesBySearch = function(search) {
  const searchArr = search.toUpperCase().split(' ')
  const regEx = new RegExp(searchArr.join('|'), 'g')

  //Filtering items that match the search
  let items = ARTICLES.filter(art => {
    let title = art.title.toUpperCase() + (art.open ? 'OPEN ACCESS' : '')
    let matches = [...new Set(title.match(regEx))]
    art.matches = matches.length
    return Boolean(art.matches)
  })

  //Sorting desc by number of matches
  items.sort((a, b) => parseFloat(b.matches) - parseFloat(a.matches))
  return items
}

export const getArticleTitle = function(id) {
  for (let i = 0; i < ARTICLES.length; i++) {
    if (ARTICLES[i].id === id) {
      return ARTICLES[i].title
    }
  }
}

const ARTICLES = [
  {
    id: '220',
    title:
      'Multidisciplinary Approach for Reducing Risk of Catheter-Associated Thrombosis',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '219',
    title:
      'Prevention of Catheter-Related Infections and Complications: A Narrative Literature Review of Vascular Care and Maintenance',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '218',
    title:
      'Clinical and economic impact of vascular access teams utilizing an IC-ECG-based tip confirmation system for peripherally inserted central catheters',
    cats: ['econ_vad'],
    open: true
  },
  {
    id: '217',
    title: 'BD Vialon: Compendio Clínico de Materiales',
    cats: ['comp_vad'],
    open: false
  },
  {
    id: '216',
    title:
      'Optimización de la atención al paciente y mejora de los resultados clínicos con catéteres intravenosos periféricos',
    cats: ['comp_vad'],
    open: false
  },
  {
    id: '215',
    title: 'Entrenamiento Competidores PIVC',
    cats: ['comp_vad'],
    open: false
  },
  {
    id: '214',
    title:
      'Risk factors for peripheral intravascular catheter-related phlebitis in critically ill patients: analysis of 3429 catheters from 23 Japanese intensive care units',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '213',
    title: 'Phlebitis associated with peripheral cannulae',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '212',
    title:
      'Infiltration During Intravenous Therapy in Neonates: Comparison of Teflon and Vialon Catheters',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '211',
    title:
      'Use of an Indwelling Peripheral Catheter for 3-5 Day Chemotherapy Administration in the Outpatient Setting',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '210',
    title:
      'Single Versus Double Occlusive Dressing Technique to Minimize Infusion Thrombophlebitis: Vialon® and Teflon® Cannulae Reassessed',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '209',
    title:
      'Complications of Intravenous Therapy: A Randomized Prospective Study-Vialon vs. Teflon',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '208',
    title:
      'Risk Factors for Infusion-related Phlebitis with Small Peripheral Venous Catheters',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '207',
    title:
      'Safety of prolonging peripheral cannula and i.v. tubing use from 72 hours to 96 hours.',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '206',
    title:
      'Effectiveness of vialon biomaterial versus teflon catheters for peripheral intravenous placement: A randomized clinical trial',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '205',
    title:
      'Effect of Two Different Short Peripheral Catheter Materials on Phlebitis Development',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '204',
    title:
      "Catheterisme veineux peripherique: influence de la composition du catheter dans I'apparition de thrombophlebites",
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '203',
    title:
      'Indwell times, complications and costs of open vs closed safety peripheral intravenous catheters: a randomized study',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '202',
    title:
      'Infusion Thrombophlebitis: A Prospective comparison of 645 vialon@ and Teflon@ Cannulae in Anaesthetic and Postoperative Use',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '201',
    title:
      'A Randomized Controlled Trial to Assess the Effectiveness of Vialon™ Cannula Versus Polytetrafluoroethylene (PTFE) Cannula in Terms of Indwelling Time and Complications in Patients Requiring Peripheral Intravenous Cannulation',
    cats: ['rele_vad'],
    open: false
  },
  {
    id: '200',
    title:
      'An In Vitro Study of Dural Lesions Produced by 25-Gauge Quincke and Whitacre Needles Evaluated by Scanning Electron Microscopy',
    cats: ['new_hypo', 'rele_hypo', 'new'],
    open: true
  },
  {
    id: '199',
    title:
      'Factors involved in the incidence of post-dural puncture headachewith the 25 gaugeWhitacre needlefor obstetric anesthesia',
    cats: ['new_hypo', 'rele_hypo', 'new'],
    open: true
  },
  {
    id: '198',
    title:
      'Memo tu support the utilization of clinical articles supporting the BD Whitacre needle in conjuction with promotional materials for BD Whitacre NRFit™ needles',
    cats: ['new_hypo', 'rele_hypo', 'new'],
    open: true
  },
  {
    id: '197',
    title: 'Association of Anaesthetists guidelines: safe vascular access 2025',
    cats: ['new_hypo', 'rele_hypo', 'new'],
    open: true
  },
  {
    id: '-es7',
    title:
      'Evaluación in situ e in vitro de dos antisépticos para banco de sangre a base de gluconato de clorhexidina/alcohol isopropílico y povidona yodada.',
    cats: ['trans_mdvc_es'],
    original: '196'
  },
  {
    id: '196',
    title:
      'In situ and in vitro evaluation of two antiseptics for blood bank based on chlorhexidine gluconate/isopropyl alcohol and povidone-iodine',
    cats: ['new_mdvc', 'rele_mdvc', 'new'],
    open: true
  },
  {
    id: '195',
    title: 'Resumen de Evidencia de la Jeringa Prellenada BD PosiFlush',
    cats: ['comp_mdvc'],
    open: true
  },
  {
    id: '194',
    title: 'Compendio Clínico BD ChloraPrep',
    cats: ['comp_mdvc'],
    open: true
  },
  {
    id: '193',
    title: 'Compendio Clínico BD Statlock',
    cats: ['comp_mdvc'],
    open: true
  },
  {
    id: '192',
    title:
      'Translating evidence into practice to prevent central venous catheter- associated bloodstream infections: A systems-based intervention',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '191',
    title:
      'Impact of a blood culture collection kit on the quality of blood culture sampling: fear and the law of unintended consequences',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '190',
    title:
      'Effectiveness of Chloraprep in Reduction of Blood Culture Contamination Rates in Emergency Department',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '189',
    title:
      'Evaluation of two chlorhexidine – alcohol-based skin disinfectants in blood donation setting',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '188',
    title:
      'Efficacy of Adding 2% (w/v) Chlorhexidine Gluconate to 70% (v/v) Isopropyl Alcohol for Skin Disinfection Prior to Peripheral Venous Cannulation',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '187',
    title:
      'Cyanoacrylate tissue adhesives – effective securement technique for intravascular catheters: in vitro testing of safety and feasibility',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '186',
    title:
      'Reducing Blood Culture Contamination in Community Hospital Emergency Departments: A Multicenter Evaluation of a Quality Improvement Intervention',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '185',
    title:
      'Normal saline flushes performed once daily maintain peripheral intravenous catheter patency',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '184',
    title:
      'Summary of Product Trials for 10,164 Patients Comparing an Intravenous Stabilizing Device to Tape',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '183',
    title:
      'The impact of flushing with pre-filled saline syringes on the incidence of peripheral venous catheter failure',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '182',
    title:
      'Clinical impact and cost-effectiveness of split-septum and single-use prefilled flushing device vs 3-way stopcock on central line-associated bloodstream infection rates in India',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '181',
    title:
      'Hemodialysis Catheter Care Strategies: A Cluster- Randomized Quality Improvement Initiative',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '180',
    title:
      'SecurAstaP trial: securement with SecurAcath versus StatLock for peripherally inserted central catheters, a randomised open trial',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '179',
    title:
      'Effect of chlorhexidine gluconate on the skin integrity at PICC line sites',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '178',
    title:
      'Bloodstream Infection Rates in Outpatient Hemodialysis Facilities Participating in a Collaborative Prevention Effort: A Quality Improvement Report',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '177',
    title:
      'Pilot trial to compare tolerance of chlorhexidine fluconate to povidone-iodine antisepsis for central venous catheter placement in neonates',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '176',
    title:
      'Skin Antisepsis Kits Containing Alcohol and Chlorhexidine Gluconate or Tincture of Iodine are Associated with Low Rates of Blood Culture Contamination',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '175',
    title:
      'An Intervention to Decrease Catheter-Related Bloodstream Infections in the ICU',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '174',
    title:
      'Comparison of Chlorhexidine and Tincture of Iodine for Skin Antisepsis in Preparation for Blood Sample Collection',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '173',
    title:
      'Effectiveness of sutureless percutaneous placement of cuffed tunneled hemodialysis catheters applying StatLock attachment devices',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '172',
    title:
      'Effectiveness, safety and comfort of StatLock securement for peripherally‐inserted central catheters: A systematic review and meta‐analysis',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '171',
    title:
      'The incidence and risk factors of peripherally inserted central catheter-related infection among cancer patients',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '170',
    title:
      'Catheter-Related Complications in Cancer Patients on Home Parenteral Nutrition: A Prospective Study of Over 51,000 Catheter Days',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '169',
    title:
      'A randomized trial of 2% chlorhexidine tincture compared with 10% aqueous povidoneeiodine for venipuncture site disinfection: Effects on blood culture contamination rates',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '168',
    title:
      'An Intervention to Decrease Catheter-Related Bloodstream Infections in the ICU',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '167',
    title: 'A novel rapid and effective donor arm disinfection method',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '166',
    title:
      'Eliminating catheter-related bloodstream infections in the intensive care unit',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '165',
    title:
      'Skin disinfection methods: prospective evaluation and postimplementation results',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '164',
    title:
      'Comparison of alcoholic chlorhexidine and povidone–iodine cutaneous antiseptics for the prevention of central venous catheter-related infection',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '163',
    title:
      'Chlorhexidine-based antiseptic solutions effectively reduce catheter-related bacteremia',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '162',
    title:
      'Combined education and skin antisepsis intervention for persistently high blood-culture contamination rates in neonatal intensive care',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '161',
    title:
      'Chlorhexidine Compared with Povidone-Iodine as Skin Preparation before Blood Culture',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '160',
    title:
      'Evaluation of ChloraPrep (2% chlorhexidine gluconate in 70% isopropyl alcohol) for skin antisepsis in preparation for blood culture collection',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '159',
    title:
      'Interventions Implemented to Reduce the Risk of Transmission of Bacteria by Transfusion in the English National Blood Service',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '158',
    title:
      'Outcomes in a nurse-led peripherally inserted central catheter program',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '157',
    title:
      'Is 2% chlorhexidine gluconate in 70% isopropyl alcohol more effective at preventing central venous catheter–related infections than routinely used chlorhexidine gluconate solutions',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '156',
    title:
      'Taste and Odour Disturbances in Pediatric Patients Undergoing IV Flush with Normal Saline Administered by Prefilled or Freshly Prepared Syringes',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '155',
    title:
      'Optimising peripheral vascular catheter care offers the greatest potential for prevention of vascular-device-related infections',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '154',
    title:
      'Implementation and evaluation of short peripheral intravenous catheter flushing guidelines',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '153',
    title:
      'A Time and Motion Study of Peripheral Venous Catheter Flushing Practice Using Manually Prepared and Prefilled Flush Syringes',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '152',
    title:
      'The Advantages of a Precision-engineered Securement Device for Fixation of Arterial Pressure-monitoring Catheters',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '151',
    title:
      'A Comparison of Taste and Odor Perception in Pediatric Patients Receiving a 0.9% Sodium Cloride Flush From 2 Different Brands of Prefilled 0.9% Sodium Chloride Syringes',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '150',
    title:
      'Chlorhexidine plus alcohol versus povidone iodine plus alcohol, combined or not with innovative devices, for prevention of short-term peripheral venous catheter infection and failure (CLEAN 3: study)',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '149',
    title:
      'Impact of flushing with aseptic non-touch technique using pre-filled flush or manually prepared syringes on central venous catheter occlusion and bloodstream infections in pediatric hemato-oncology patiens: A randomized controlled study',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '148',
    title:
      'Effectiveness of a central line bundle campaign on line-associated infections in the intensive care unit',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '147',
    title:
      'Impact of a modified Broviac maintenance care bundle on bloodstream infections in paediatric cancer patients',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '146',
    title: 'Why Are We Stuck on Tape and Suture?',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '145',
    title:
      'Central line bundle for prevention of central line-associated bloodstream infection for totally implantable venous access devices (ports) in pediatric cancer patients',
    cats: ['new_mdvc', 'new'],
    open: true
  },
  {
    id: '144',
    title:
      'Clinical impact and cost-effectiveness of a central line bundle including split-septum and single-use prefilled flushing devices on central line-associated bloodstream infection rates in a pediatric intensive care unit',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '143',
    title:
      'Clinical evaluation of a securement device used on midline catheters',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '142',
    title:
      'Chlorhexidine Compared with Povidone-Iodine Solution for Vascular Catheter–Site Care: A Meta-Analysis',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '141',
    title:
      'Assessment of potential differences between pre-filled and manually prepared syringe use during vascular access device management in a pediatric intensive care unit',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '140',
    title:
      'Taste and/or Odour Disturbances in Pediatric Patients Undergoing IV Flush with Normal Saline Administered by Prefilled Syringe',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '139',
    title:
      'Pre-filled normal saline syringes to reduce totally implantable venous access device-associated bloodstream infection: a single institution pilot study',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '138',
    title:
      'Skin disinfection with a single-step 2% chlorhexidine swab is more effective than a two-step povidone-iodine method in preventing bacterial contamination of apheresis platelets',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '137',
    title:
      'Skin antisepsis with chlorhexidine–alcohol versus povidone iodine–alcohol, with and without skin scrubbing, for prevention of intravascular-catheter-related infection (CLEAN): an open-label, multicentre, randomised, controlled, two-by-two factorial trial',
    cats: ['new_mdvc'],
    open: true
  },
  {
    id: '136',
    title: 'Infusion Therapy Standards of Practice',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '135',
    title:
      'Management of Hospital In The Home (HITH) Peripherally Inserted Central Catheters: A Retrospective Cohort Study',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '134',
    title:
      'Prospective evaluation of systematic use of peripherally inserted central catheters (PICC lines) for the home care after allogeneic hematopoietic stem cells transplantation',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '133',
    title:
      'Peripherally inserted central venous catheter (PICC) in outpatient and inpatient oncological treatment',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '132',
    title:
      'An observational study on the use of long acting buprenorphine ( Sublocade) and a Tamper resistant PICC for Outpatient IV antibiotic administration in Patients with serious infections and Opioid Use Disorder; The STOP OUD project',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '131',
    title:
      'Management of Hospital In The Home (HITH) Peripherally Inserted Central Catheters: A Retrospective Cohort Study',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '130',
    title:
      'Prospective evaluation of systematic use of peripherally inserted central catheters (PICC lines) for the home care after allogeneic hematopoietic stem cells transplantation',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '128',
    title:
      'Indwell times, complications and costs of open vs closed safety peripheral intravenous catheters: a randomized study',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '127',
    title:
      'Chlorhexidine plus alcohol versus povidone iodine plus alcohol, combined or not with innovative devices, for prevention of short-term peripheral venous catheter infection and failure (CLEAN 3 study)',
    cats: ['new_mdvc', 'rele_mdvc', 'rele_vad'],
    open: true
  },
  {
    id: '126',
    title:
      'Estudio sobre la reducción de eventos adversos en pacientes y problemas de bioseguridad de los profesionales derivados de la aplicación de catéteres vasculares en urgencias',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '125',
    title: 'The journal of the Association for Vascular Access',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '124',
    title:
      'Unfavorable peripheral intravenous catheter replacements can be reduced using an integrated closed intravenous catheter system',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '123',
    title:
      'The impact of a notched peripheral intravenous catheter on the first attempt success rate in hospitalized adults: Block-randomized trial',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '122',
    title:
      'A randomized controlled study to compare first stick success with Instaflash technology: The FIRSST study',
    cats: ['rele_vad'],
    open: true
  },
  {
    id: '121',
    title:
      'Integrated versus nonintegrated peripheral intravenous catheter in hospitalized adults (OPTIMUM): A randomized controlled trial',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '120',
    title:
      'Cutting Peripherally Inserted Central Catheters May Lead to Increased Rates of Catheter-Related Deep Vein Thrombosis',
    cats: ['new_vad'],
    open: true
  },
  {
    id: '119',
    title:
      'JAVA: Trimming of Peripherally Inserted Central Catheters: The End Result',
    cats: ['new_vad'],
    open: true
  },
  {
    id: '118',
    title:
      'Evaluation of Indicators of a Vascular Access Device Program led by Nursing Professionals in a High-complexity University Hospital in Colombia',
    cats: ['new_vad'],
    open: true
  },
  {
    id: '117',
    title:
      'Catéteres venosos de inserción periférica (PICC): un avance en las terapias intravenosas de larga permanencia',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '116',
    title:
      'Vascular access in COVID-19 patients: Smart decisions for maximal safety',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '115',
    title:
      'Evaluation of Skin Colonisation And Placement of vascular access device Exit sites (ESCAPE Study)',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '114',
    title: 'Midline clinical article summaries',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '113',
    title:
      'Infection free midline catheter implementation at a community hospital (2 years)',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '112',
    title: 'The midline catheter: A clinical review',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '111',
    title: 'Evaluation of midline vascular access: A descriptive study',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '110',
    title:
      'How to Establish an Effective Midline Program: A Case Study of 2 Hospitals',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '109',
    title:
      'The Utility of Midline Intravenous Catheters in Critically Ill Emergency Department Patients',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '108',
    title:
      'Journal of the Association for Vascular Access. Evaluation of Processes, Outcomes and Use of Midline Peripheral Catheters for the Purpose of Blood Collection',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '107',
    title:
      'Análisis de los parámetros de calidad y de costos de uso de catéter central de inserción periférica frente al catéter de inserción central en población pediátrica del Hospital Universitario del Valle, Cali, Colombia. 2011-2014',
    cats: ['econ_vad'],
    open: true
  },
  {
    id: '106',
    title: 'Compendio de Posiflush',
    cats: ['comp_mdvc']
  },
  {
    id: '105',
    title:
      'Management of antithrombotic treatment and bleeding disorders in patients requiring venous access devices: A systematic review and a GAVeCeLT consensus statement',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '104',
    title: 'Guía de Accesos Vasculares 2021 de la RNAO',
    cats: ['comp_vad'],
    open: true
  },
  {
    id: '103',
    title: 'Infusion Therapy Standards of Practice 2016',
    cats: ['comp_vad'],
    open: true
  },
  {
    id: '102',
    title: 'Infusion Therapy Standards of Practice 2021',
    cats: ['comp_vad'],
    open: true
  },
  {
    id: '101',
    title:
      'Defining risk factors associated with difficult peripheral venous Cannulation: A systematic review and meta-analysis',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '100',
    title: 'Peripherally inserted central venous catheters (PICC)',
    cats: ['new_vad', 'rele_vad', 'new_mdvc', 'rele_mdvc']
  },
  {
    id: '99',
    title:
      'Peripherally Inserted Central Catheter Thrombosis Following placement via electrocardiography vs. traditional methods: an analysis of 42,687 patients',
    cats: ['new_vad', 'rele_vad', 'new_mdvc', 'rele_mdvc']
  },
  {
    id: '98',
    title:
      'Inadequate positioning of central venous catheters inserted at intensive care units',
    cats: ['new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '97',
    title:
      'Strategies to prevent central line-associated bloodstream infections in acute-care hospitals: 2022 Update',
    cats: ['new_mdvc', 'rele_mdvc', 'new_vad', 'rele_vad'],
    open: true
  },
  {
    id: '96',
    title:
      'The impact of flushing with pre-filled saline syringes on the incidence of peripheral venous catheter failure: A quasi-experimental study',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '95',
    title:
      'Effectiveness of vialon biomaterial versus teflon catheters for peripheral intravenous placement: A randomized clinical trial',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '94',
    title: 'BD NeoflonTM Pro IV Catheter material comparison testing',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '93',
    title:
      'Technologies in pediatric vascular access: have we improved success rate in peripheral vein cannulation?',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '92',
    title:
      'A meta-analysis of the comparison of phlebitis between midline catheters and peripherally inserted central catheters in infusion therapy',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '91',
    title:
      'Peripherally Inserted Central Catheters in Pediatric Patients Performed by Radiologists Using Fluoroscopy',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '90',
    title:
      'Risk of infection due to medical interventions via central venous catheters or implantable venous access port systems at the middle port of a three-way cock: luer lock cap vs. luer access split septum system (Q-Syte)',
    cats: ['rele_vad']
  },
  {
    id: '89',
    title:
      'Impact of MaxZero™ needle-free connector on the incidence of central venous catheter-related infections in surgical intensive care unit*',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '88',
    title:
      'Clinical impact and cost-effectiveness of split-septum and single-use prefilled flushing device vs 3-way stopcock on central line-associated bloodstream infection rates in India',
    cats: ['econ_vad']
  },
  {
    id: '87',
    title:
      'Pre-filled normal saline syringes to reduce totally implantable venous access device-associated bloodstream infection: A single institution pilot study',
    cats: ['rele_vad']
  },
  {
    id: '86',
    title: 'Accepted but Unacceptable: Peripheral IV Catheter Failure',
    cats: ['rele_vad']
  },
  {
    id: '85',
    title:
      'Needleless connector nursing care e Current practices, knowledge, and attitudes: An Australian perspective',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '84',
    title:
      'European recommendations on the proper indication and use of peripheral venous access devices (the ERPIUP consensus): A WoCoVA project',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '83',
    title:
      'A Time and Motion Study of Peripheral Venous Catheter Flushing Practice Using Manually Prepared and Prefilled Flush Syringes',
    cats: ['rele_mdvc']
  },
  {
    id: '40',
    title:
      'An eight-year multicenter study on short-term peripheral intravenous catheter–related bloodstream infection rates in 100 intensive care units of 9 countries in Latin America: Argentina, Brazil, Colombia, Costa Rica, Dominican Republic, Ecuador, Mexico, Panama, and Venezuela.',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '41',
    title:
      'Epicutaneo-caval catheters in neonates: New insights and new suggestions from the recent literature',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '42',
    title:
      'Guidelines of the Italian Association of Pediatric Hematology and Oncology for the management of the central venous access devices in pediatric patients with onco-hematological disease',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '43',
    title:
      'Reliability of cutaneous landmarks for the catheter length assessment during peripherally inserted central catheter insertion: A retrospective observational study',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '44',
    title:
      'Changing the syringe pump: A challenging procedure in critically ill patients',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '45',
    title:
      'An observational study of the securemen  of central venous access devices with a subcutaneous anchor device in a paediatric population at a tertiary level hospital',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '46',
    title:
      'Computer-assisted needle navigation forpediatric internal jugular central venous cannulation: A feasibility study',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '47',
    title:
      'Transthoracic echocardiography as bedside technique to verify tip location of central venous catheters in patients with atrial arrhythmia',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '48',
    title:
      'Chinesization of the quality of life assessment, venous device-port, and its reliability and validity tests for patients with breast cancer',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '49',
    title:
      'Effects of passive music therapy on anxiety and vital signs in lung cancer patients undergoing peripherally inserted central catheter placement procedure',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '50',
    title:
      'Factors affecting superficial vein visibility at the upper limb in healthy young adults: A cross-sectional observational study',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '51',
    title:
      'Clinical impact of needle-free connector design: A systematic review of literature',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '52',
    title:
      'Experimental study of the POP technique: focus on the physical basis of the process',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '53',
    title:
      'Ultrasound-guided proximal versus distal axillary vein puncture in elderly patients: A randomized controlled trial',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '54',
    title:
      'Economic evaluation of peripherally inserted central catheter and other venous access devices: A scoping review',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '55',
    title:
      'Single-access ultrasound-guided tunneled femoral lines in critically ill pediatric patients',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '56',
    title:
      'Methods for microbial needleless connector decontamination: A systematic review and metaanalysis − Interpret results with caution',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '57',
    title:
      'Impact of needle-free connectors compared with 3-way stopcocks on catheter-related bloodstream infection rates: A meta-analysis',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '58',
    title:
      'A prospective clinical trial to evaluate the microbial barrier of a needleless connector',
    cats: ['rele_vad']
  },
  {
    id: '59',
    title:
      'Clinical evidence compendium Reducing the risk of healthcare-related complications with a 2% chlorhexidine gluconate and 70% isopropyl alcohol solution in a plastic applicator',
    cats: ['new_vad', 'rele_vad', 'comp_vad']
  },
  {
    id: '60',
    title:
      'Consenso clínico en Antisepsia de la piel antes de cirugía e inserción',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '61',
    title:
      'Clinical impact of needle-free connector design: A systematic review of literature',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '62',
    title:
      'The Impact of Needleless Connector Device Design on Central Venous Catheter Occlusion in Children: A Prospective, Controlled Trial',
    cats: ['rele_vad']
  },
  {
    id: '63',
    title:
      'Response to a Letter to the Editor regarding "Connectorsas a risk factor for bloodassociated infections (3-way stopcock and needleless connector): A randomizedexperimental study"',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '64',
    title:
      'Connectors as a risk factor for blood-associated infections (3-way stopcock and needleless connector): A randomized-experimental study',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '65',
    title:
      'A prospective clinical study to investigate the microbial contamination of a needleless connector',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '66',
    title:
      'Meta-analysis on central lineeassociated bloodstream infections associated with a needleless intravenous connector with a new engineering design',
    cats: ['rele_iva']
  },
  {
    id: '67',
    title:
      'Summary of evidence on the effectiveness of the MaxPlus™ and MaxZero™ needle-free connectors',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '68',
    title:
      'Risk factors for central venous catheter-related bloodstream infection: a 1073-patient study',
    cats: ['rele_iva']
  },
  {
    id: '69',
    title:
      'Response to the Letter to the Editor regarding "Methods for microbial needleless connecto decontamination: A systematic review and meta-analysis"',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '70',
    title:
      'Methods for microbial needleless connector decontamination: A systematic review and meta-analysis',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '71',
    title:
      'Health Care–Associated Bloodstream Infections Associated with Negative- or Positive-Pressure or Displacement Mechanical Valve Needleless Connectors',
    cats: ['rele_iva']
  },
  {
    id: '72',
    title:
      'Reduction of central Line- Associated Bloodstream Infection Rates in Patients in the Adult Intensive Care Unit',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '73',
    title:
      'Needle-free connectors catheter-related bloodstream infections: a prospective randomized controlled trial',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '74',
    title:
      'Comparison of contamination between conventional three-way stopcock and needleless injection device: A randomized controlled trial',
    cats: ['rele_vad']
  },
  {
    id: '75',
    title:
      'A prospective clinical trial to assess peripheral venous catheter– related phlebitis using needleless connectors in a surgery department',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '76',
    title:
      'Impact of needle-free connectors compared with 3-way stopcocks on catheter-related bloodstream infection rates: A meta-analysis',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '77',
    title:
      'Clinical impact of needle-free connector design: A systematic review of literature',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '78',
    title:
      'Impact of needle-free connectors compared with 3-way stopcocks on catheter-related bloodstream infection rates: A meta-analysis',
    cats: ['new_iva', 'rele_iva']
  },
  {
    id: '79',
    title:
      'Central line bundle including split-septum device and single-use prefilled flushing syringes to prevent port-associated bloodstream infections: a cost and resource-utilization analysis',
    cats: ['new_mdvc', 'rele_mdvc', 'econ_mdvc']
  },
  {
    id: '80',
    title:
      'A prospective clinical trial to evaluate the microbial barrier of a needleless connector',
    cats: ['rele_vad']
  },
  {
    id: '81',
    title: 'Catheter Occlusion in Home Infusion',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '82',
    title:
      'Summary - The impact of flushing with pre-filled saline syringes on the incidence of peripheral venous catheter failure: A quasi-experimental study',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '1',
    title:
      'Cost-Effectiveness of a Guided Peripherally Inserted Central Catheter Placement System: A Single-Center Cohort Study',
    cats: ['new_vad', 'rele_vad', 'econ_vad']
  },
  {
    id: '2',
    title:
      'Can Peripherally Inserted Central Catheters Be Safely Placed in Patients with Cancer Receiving Chemotherapy? A Retrospective Study of Almost 400,000 Catheter-Days',
    cats: ['new_vad', 'rele_vad', 'econ_vad']
  },
  {
    id: '5',
    title:
      'Infectious complications in home parenteral nutrition: a long-term study with peripherally inserted central catheters, tunneled catheters and ports',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '6',
    title:
      'Does ultrasound guidance for peripherally inserted central catheter (PICC) insertion reduce the incidence of tip malposition? – a randomized trial',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '9',
    title:
      'Improved Care and Reduced Costs for Patients Requiring Peripherally Inserted Central Catheters: the Role of Bedside Ultrasound and a Dedicated Team',
    cats: ['rele_vad', 'econ_vad']
  },
  {
    id: '11',
    title:
      'Experience of Peripherally Inserted Central Venous Catheter in Patients with Hematologic Diseases',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '14',
    title:
      'Peripherally Inserted Central Catheter Experience in Long-Term Home Parenteral Nutrition Patients',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '15',
    title:
      'Peripherally Inserted Central Catheters (PICCs) in Cancer Patients Under Chemotherapy: A Prospective Study on the Incidence of Complications and Overall Failures',
    cats: ['rele_vad']
  },
  {
    id: '16',
    title:
      'Peripherally inserted central catheters are associated with lower risk of bloodstream infection compared with central venous catheters in paediatric intensive care patients: a propensity-adjusted analysis',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '20',
    title:
      'Front-line central vascular access devices in acute leukemias – Peripherally Inserted Central Catheter (PICC) versus traditional Central Venous Catheter (CVC) : A Phase IV Randomized Trial',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '21',
    title:
      'A comparison of silicone and polyurethane PICC lines and postinsertion complication rates: a systematic review',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '22',
    title:
      'The Ideal Use of the Power Injectable Peripherally Inserted Central Catheter in the Pediatric Population',
    cats: ['rele_vad']
  },
  {
    id: '23',
    title: 'Choosing the Right Intravenous Catheter',
    cats: ['rele_vad']
  },
  {
    id: '25',
    title:
      'Advantages and disadvantages of peripherally inserted central venous catheters (PICC) compared to other central venous lines: A systematic review of the literature',
    cats: ['rele_vad']
  },
  {
    id: '26',
    title:
      'Focus on peripherally inserted central catheters in critically ill patients',
    cats: ['rele_vad']
  },
  {
    id: '29',
    title:
      'Peripherally Inserted Central Catheters May Lower the Incidence of Catheter-Related Blood Stream Infections in Patients in Surgical Intensive Care Units',
    cats: ['rele_vad']
  },
  {
    id: '34',
    title:
      'Peripherally inserted central catheters in the treatment of children with cancer: Results of a multicenter study',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '35',
    title:
      'Meta-analysis of intracavitary electrocardiogram guidance for peripherally inserted central catheter placement',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '37',
    title:
      'Clinical management of peripherally inserted central catheters compared to conventional central venous catheters in patients with hematological malignancies: A large multicenter study of the REL GROUP',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '38',
    title:
      'Living with a peripherally inserted central catheter: the perspective of cancer outpatients — a qualitative study',
    cats: ['new_vad', 'rele_vad']
  },
  {
    id: '39',
    title:
      'Catéteres centrales de inserción periférica: un ahorro, una comodidad, muchas ventajas',
    cats: ['new_vad', 'rele_vad', 'econ_vad']
  },
  {
    id: '-es6',
    title:
      'El impacto del enjuague con jeringas prellenadas con solución salina sobre la incidencia de falla del catéter venoso periférico: Un estudio cuasi-experimental',
    cats: ['trans_vad_es'],
    original: '-o6'
  },
  {
    id: '-o6',
    title:
      'The impact of flushing with pre-filled saline syringes on the incidence of peripheral venous catheter failure: A quasi-experimental study',
    cats: ['new_mdvc', 'rele_mdvc']
  },
  {
    id: '-es5',
    title:
      'Ocurrencia y tasa de incidencia de flebitis y de complicaciones asociadas a catéteres intravasculares periféricos en pacientes críticos: un estudio de cohorte prospectivo (estudio AMOR-VENUS)',
    cats: ['trans_vad_es'],
    original: '-o5'
  },
  {
    id: '-pt5',
    title:
      'Ocorrência e taxa de incidência de flebite e complicações associadas a cateteres intravasculares periféricos em pacientes críticos: um estudo de tipo prospectivo (estudo AMOR-VÉNUS)',
    cats: ['trans_vad_pt'],
    original: '-o5'
  },
  {
    id: '-o5',
    title:
      'Occurrence and incidence rate of peripheral intravascular catheter-related phlebitis and complications in critically ill patients: a prospective cohort stud (AMOR-VENUS study)',
    cats: ['new_vad', 'new_rele']
  },
  {
    id: '-es1',
    title:
      'Catéter venoso central de inserción periférica: una experiencia en un hospital de alta complejidad',
    cats: ['trans_vad_es'],
    original: '-o1'
  },
  {
    id: '-o1',
    title:
      'Peripherally-inserted central venous catheter: an experience in a high-complexity hospital',
    cats: []
  },
  {
    id: '-es2',
    title: 'Superación manual del examen CRNI',
    cats: ['trans_vad_es'],
    original: '-o2'
  },
  {
    id: '-o2',
    title: 'Rise above CRNI® exam handbook',
    cats: []
  },
  {
    id: '-es4',
    title:
      'Evaluación de procedimientos, resultados, y uso de catéteres periféricos de línea media con el propósito de recolectar sangre',
    cats: ['trans_vad_es'],
    original: '-o4'
  },
  {
    id: '-o4',
    title:
      'Evaluation of Processes, Outcomes, and Use of Midline Peripheral Catheters for the Purpose of Blood Collection',
    cats: []
  }
]
